import { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../components/card/card';

import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { GetEquipmentsAssignationByEquipmentsId } from '../../../store/FLEET/EquipmentsAssignment/equipmentsAssignmentSlice';
// import EquipmentsAssignmentList from './EquipmentsAssignmentList';

import Loading from '../../../components/Shared/Loader/Loading';
import useGetEquipmentsList from '../../../hooks/FLeet/useGetEquipmentsList';
import NtxTable from '@components/DataTable/NtxTable';
import NtxCustomModal from '@components/Modal/NtxCustomModal';
import DetilesScan from './DetilesScan';

const EquipmentsAssignment = () => {
  const [data, setData] = useState<{ scanningType: string; assignationId: string }>({
    scanningType: '',
    assignationId: ''
  });
  const { Id } = useParams();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const Navigate = useNavigate();
  const [show, setShow] = useState(false);

  const { EquipmentsList } = useGetEquipmentsList();

  const loading = useAppSelector(state => state.EquipmentsAssignment.loading);
  const error = useAppSelector(state => state.EquipmentsAssignment.error);

  const Equipment = EquipmentsList.find(f => f.id === Id);

  useEffect(() => {
    if (Id) {
      dispatch(GetEquipmentsAssignationByEquipmentsId(Id));
    }
  }, [Id, dispatch]);

  const { AssignationListByEquipmentsId } = useAppSelector(state => state.EquipmentsAssignment);

  const columns = [
    { title: t('DriverName'), key: 'Name' },
    { title: t('Start Date'), key: 'sdate' },
    { title: t('End_Date'), key: 'edate' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = AssignationListByEquipmentsId?.slice()
    ?.sort((a, b) => {
      const dateA = new Date(a.deliveryDateFrom);
      const dateB = new Date(b.deliveryDateFrom);
      return dateB.getTime() - dateA.getTime();
    })
    ?.map(item => {
      let rowClass;

      return {
        Name: i18n.language === 'en' ? item.peopleName : item.peopleName2,
        sdate: item.deliveryDateFrom,
        edate: item.deliveryDateTo,

        action: (
          <>
            <button
              type='button'
              className='btn btn-sm btn-outline-theme me-2'
              onClick={() => {
                setData({ assignationId: item.id, scanningType: 'Handover' });
                setShow(true);
              }}
            >
              {/* <i className='far fa-arrow-alt-circle-up fa-lg fa-fw'></i> */}
              {t('Handover Details')}
            </button>
            <button
              type='button'
              className='btn btn-sm btn-outline-theme'
              hidden={item.deliveryDateTo === null}
              onClick={() => {
                setData({ assignationId: item.id, scanningType: 'TakeOver' });
                setShow(true);
              }}
            >
              {/* <i className='far fa-arrow-alt-circle-down fa-lg fa-fw'></i> */}
              {t('Takeover Details')}
            </button>
          </>
        ),

        rowClass // استخدم rowClass هنا
      };
    });

  //____________________________
  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'Vehicles',
              link: '/FLEET/Equipments'
            },
            {
              name: 'VehicleLogs',
              link: null
            }
          ]}
          PageName='VehicleLogs'
          subtitle={Equipment?.plateNo}
        />
        <div className='ms-auto'>
          <button
            type='button'
            className='btn btn   btn-secondary mb-1 w-100 rounded-0'
            onClick={() => Navigate('/FLEET/Equipments', { replace: true })}
          >
            {t('Back')}
          </button>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <NtxCustomModal
        show={show}
        setShow={setShow}
        width='94%'
        title={` Handover & Takeover Information - ${i18n.language === 'en' ? Equipment?.name : Equipment?.name2}`}
      >
        <DetilesScan
          assignationId={data.assignationId}
          scanningType={data.scanningType}
          onclose={() => setShow(false)}
        />
      </NtxCustomModal>
    </>
  );
};

export default EquipmentsAssignment;
